export default {"src":"/_next/static/media/ic-youtube.61bd5841.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};